import type React from "react";
import { ReactComponent as Svg } from "./assets/stopwatch.svg";
import * as styles from "./Icon.module.scss";

type StopwatchProps = React.SVGProps<SVGSVGElement>;

export const Stopwatch = ({ className, ...props }: StopwatchProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
